import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Table, message, Tooltip, Popover, Mention } from "antd";
import InputForm from "./InputForm";
import axios from "axios";
import "../pages/Pages.css";
import "./Form.css";
import moment from "moment-timezone";
import { maskDate } from "../utils/Masker";
import numeral from "numeral";
import JustificativaForm from './JustificativaForm';

const formatHora = 'HH:mm';
const { Item: ItemForm } = Form;
const { Column } = Table;

export default class AnaliseProducaoOPForm extends Component {
  state = {
    carregando: false,
    carregandoForm: false,

    listaRegistros: [],
    selectedRowKeys: [],
    pi_dt_producao: moment().format('DD/MM/YYYY'),
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionadoProducao !== propsAnterior.registroSelecionadoProducao) {
      this.setState({
        registro: this.props.registroSelecionadoProducao,
        carregandoForm: true,
      }, this.getListaRegistros);
    }
  }

  componentDidMount() {

  }

  getListaRegistros = () => {
    this.setState({ carregandoForm: true, selectedRowKeys: [], listaRegistros: [] });

    axios
      .get('/producao/listaProdutosAnaliseProducao', {
        params: {
          tipoTela: this.props.tipoTela
        }
      })
      .then(response => {
        this.setState({
          listaRegistros: response.data,
          carregandoForm: false,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregandoForm: false,
        });
      });
  };




  onOK = () => {
    const { selectedRowKeys, listaRegistros, pi_dt_producao } = this.state;

    if ((!selectedRowKeys) || (selectedRowKeys.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Selecione algum pedido' });
      return;
    }

    Modal.confirm({
      title: 'Gerar Análise Laboratorial',
      content: `Deseja gerar as análise laboratoriail das produções selecionados para o dia ${pi_dt_producao} ?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {

        let listaProdutos = [];
        for (var x in selectedRowKeys) {
          const item = selectedRowKeys[x].split('_');
          const registroIndex = listaRegistros.findIndex(registro => String(registro.op_idf) === String(item[0]) && String(registro.op_pessoa) === String(item[1]) && String(registro.pi_item) === String(item[2]) && String(registro.pi_seq) === String(item[3]))

          if ((registroIndex >= 0) &&
            (listaRegistros[registroIndex].qtde_produzida) &&
            (parseFloat(listaRegistros[registroIndex].qtde_produzida) > 0) &&
            (parseFloat(listaRegistros[registroIndex].qtde_produzida) <= (parseFloat(listaRegistros[registroIndex].pi_qtde) - (listaRegistros[registroIndex].qtde_analisada ? parseFloat(listaRegistros[registroIndex].qtde_analisada) : 0)))) {

            listaProdutos.push(selectedRowKeys[x] + '_' + parseFloat(listaRegistros[registroIndex].qtde_produzida))

          }
        };

        if (listaProdutos.length > 0) {

          const reg = {
            listaPedidos: listaProdutos,
            pi_dt_producao: moment(pi_dt_producao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            tipo: 'PROD',
          }

          // console.log('onOK', reg)
          // return;

          this.setState({ carregando: true })

          axios.post(`/analiseProducao/storeAnalisePedidos`, reg)
            .then(response => {
              message.success('Análise gravada com sucesso');
              this.setState({ carregando: false, selectedRowKeys: [] });
              if (listaProdutos.length === 1) {
                this.props.onFecharModalOrdemProducaoAbrirFormClick(response.data);
              } else {
                this.props.onFecharModalOrdemProducaoClick();
              }
            })
            .catch(error => {
              console.error(error.response);
              this.setState({
                carregando: false
              })
              if (error.response.status === 412) {
                Modal.error({ title: 'Falha ao Gravar', content: error.response.data, });
              } else {
                Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
              }
            })
        } else {
          Modal.warning({ title: 'Aviso!', content: 'Informe a quantidade produzida correta para cada item selecionado' });
          return;
        }
      }
    })
  };



  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span style={{ fontSize: 11 }}>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  renderValor = (vlr, registro) => {
    return (
      <span style={{ fontSize: 11 }}> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };



  renderQtdeProduzida = (data, registro) => {
    // console.log('renderQtdeProduzida', registro)
    let disab = false;
    for (var x in this.state.selectedRowKeys) {
      if (this.state.selectedRowKeys[x] === registro.op_idf + '_' + registro.op_pessoa + '_' + registro.pi_item + '_' + registro.pi_seq) {
        disab = true;
      }
    }


    if (registro.prod_medida2_conversao > 1) {

      const qtde = registro.prod_medida2_conversao;
      const total = registro.pi_qtde;
      var qtdeSelect = [];

      for (let i = qtde; i <= total; i = i + qtde) {
        qtdeSelect.push({
          key: i,
          label: String(i),
        });
      }
      const qtdeAux = {
        key: String(registro.qtde_produzida),
        label: String(registro.qtde_produzida),
      }

      return (
        <Col xs={24} style={{ marginTop: -5, marginBottom: -30 }}>
          <InputForm
            type="select"
            id="qtde_produzida"
            ref="qtde_produzida"
            value={qtdeAux}
            placeholder="Selecione"
            onChange={situacao => this.onChangeQtde(registro, situacao)}
            data={qtdeSelect}
            validator={value => Boolean(value)}
            style={{ width: "100%" }}
            disabled={!disab}
          />
        </Col>
      )

    } else {
      return (
        <Col xs={24} style={{ marginTop: -5, marginBottom: -30 }}>
          <InputForm
            type="number"
            id="qtde_produzida"
            ref="qtde_produzida"
            value={registro.qtde_produzida}
            onChange={(value) => {
              registro.qtde_produzida = value.target.value;
              // this.forceUpdate();
            }}
            disabled={!disab}
          />
        </Col>
      )
    }

  }

  onChangeQtde = (registro, event) => {
    registro.qtde_produzida = parseInt(event.target.value.key);
    this.setState({
      registro,
    })
  };









  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    this.setState({ [id]: value });
  };

  onSelectChange = selectedRowKeys => {
    // console.log('selectedRowKeys changed: ', selectedRowKeys);
    this.setState({ selectedRowKeys });
  };





  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------


  render() {
    const { onFecharModalOrdemProducaoClick, visivel, carregando } = this.props;
    const { listaRegistros, carregandoForm, selectedRowKeys, pi_dt_producao, registro } = this.state;

    // console.log('AnaliseProducaoOPForm.this.state: ', this.state);

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const hasSelected = selectedRowKeys.length > 0;

    return (
      <Modal
        title={"Produção para Análise de Laboratorial"}
        visible={visivel}
        destroyOnClose
        onCancel={onFecharModalOrdemProducaoClick}
        footer={null}
        width={"80%"}
        style={{ top: 30 }}
      >
        <div >

          <Row style={{ height: 480 }}>
            <Row>
              <span style={{ marginTop: 8, fontSize: 15, fontWeight: 'bold' }}>
                {hasSelected ? `Selecionados ${selectedRowKeys.length} items` : ''}
              </span>

              <Col xs={24} sm={8} style={{ marginTop: -15 }}>
                <span>{'Data Fabricação'}</span>
                <InputForm
                  type="date"
                  id="pi_dt_producao"
                  ref="pi_dt_producao"
                  value={pi_dt_producao}
                  masker={maskDate}
                  validator={data => moment(data, "DD/MM/YYYY", true).isValid()}
                  dateFormat="DD/MM/YYYY"
                  onChange={this.onChange}
                  errorMessage="Formato correto DD/MM/AAAA"
                  className="input-data-avaliacao"
                // style={{ width: "100%" }}
                />
              </Col>
            </Row>

            <Row style={{}}>
              <Table
                loading={{
                  spinning: carregandoForm,
                  tip: 'Carregando. Aguarde...',
                  size: "large"
                }}
                dataSource={listaRegistros}
                pagination={false}
                scroll={{ y: 360 }}
                rowKey={(listaRegistros => listaRegistros.op_idf + '_' + listaRegistros.op_pessoa + '_' + listaRegistros.pi_item + '_' + listaRegistros.pi_seq)}

                rowSelection={rowSelection}
              >
                <Column
                  key="op_numero"
                  dataIndex="op_numero"
                  title="Produção"
                  width={"8%"}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="op_dt_emissao"
                  dataIndex="op_dt_emissao"
                  title="Data"
                  render={this.renderData}
                  width={"8%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="pes_nome"
                  dataIndex="pes_nome"
                  title="Cliente"
                  width={"8%"}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="pi_qtde"
                  dataIndex="pi_qtde"
                  title="Qtde Produção"
                  width={"10%"}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="peso_producao"
                  dataIndex="peso_producao"
                  title="Peso Produção"
                  width={"10%"}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="qtde_analisada"
                  dataIndex="qtde_analisada"
                  title="Qtde Analisada"
                  width={"10%"}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="peso_analisada"
                  dataIndex="peso_analisada"
                  title="Peso Analisada"
                  width={"10%"}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="prod_codigo"
                  dataIndex="prod_codigo"
                  title="Produto"
                  width={"8%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="prod_descricao"
                  dataIndex="prod_descricao"
                  title="Descrição do Produto"
                  width={"20%"}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="qtde_produzida"
                  dataIndex="qtde_produzida"
                  title="Qtde Produzida"
                  render={this.renderQtdeProduzida}
                  width={'8%'}
                  align="right"
                  className="listaCadastro"
                />
              </Table>
            </Row>

          </Row>


          <ItemForm>
            <div className="divider-form" />
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  onClick={this.onOK}
                  loading={carregando}
                  className="botoesModalForm2x"
                >
                  {this.props.tipoTela === 'OP' ? 'Gerar Produção' : 'Gerar Análises'}
                </Button>

                <Button
                  htmlType="button"
                  onClick={onFecharModalOrdemProducaoClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AnaliseProducaoOPForm.js